import axios from 'utils/axios';

// Whole org roster × every day of `month` (YYYY-MM), goals and actuals. ORG_ADMIN only.
export async function fetchOrgMonthGoalProgress(month) {
    try {
        const response = await axios.get(`/api/org-id/{orgId}/productivity-goal-day/org-month`, {
            params: { month }
        });
        return response;
    } catch (e) {
        if (e && e.statusCode && e.message) {
            throw e;
        }
        throw new Error('unknown error');
    }
}

// goals: [{ userId, goalDate: 'YYYY-MM-DD', goalHours }] — upserted as one audited batch.
export async function postBulkGoalDays(goals) {
    try {
        const response = await axios.post(`/api/org-id/{orgId}/productivity-goal-day/bulk`, { goals });
        return response;
    } catch (e) {
        if (e && e.statusCode && e.message) {
            return e;
        }
        return {
            message: 'unknown error'
        };
    }
}
